import { render } from "./UiClose.vue?vue&type=template&id=4c7ae1d7&scoped=true&lang=pug"
import script from "./UiClose.vue?vue&type=script&lang=js"
export * from "./UiClose.vue?vue&type=script&lang=js"

import "./UiClose.vue?vue&type=style&index=0&id=4c7ae1d7&lang=sass&scoped=true"

import exportComponent from "/home/runner/work/valeriya-artist/valeriya-artist/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c7ae1d7"]])

export default __exports__